module.exports = __webpack_public_path__ + "static/media/venetia.2af0646d.jpg";